import type { Locale } from 'vue-i18n'
import { createI18n } from 'vue-i18n'
import type { TranslationKey } from '@widgets/shared/services/translate/types'
import enUS from '@widgets/shared/locales/en_US.json'
import { numberFormats } from '@/config/formatting'

class TranslateService {
  protected i18n: any

  protected defaultLocale = 'en-US'

  constructor() {
    this.i18n = createI18n({
      numberFormats,
      legacy: true,
      locale: this.defaultLocale,
      fallbackLocale: this.defaultLocale,
      messages: {
        ...enUS,
      },
      silentFallbackWarn: true,
    })
  }

  public t(key: TranslationKey, params?: Record<string, any>): string {
    return this.i18n.global.t(key, params)
  }

  public tc(key: TranslationKey, count?: number, params?: { [key: string]: any }): string {
    return this.t(key, { ...params, count })
  }

  public n(str: number, type: string, locale?: Locale, params?: Record<string, any>): string {
    return this.i18n.global.n(str, type, locale, params)
  }

  public te(str: TranslationKey): boolean {
    return this.i18n.global.te(str)
  }
}

export default new TranslateService()
